  
  import React from 'react';
  import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
  import { LocalizationProvider } from '@mui/x-date-pickers';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
  
  export function getDateFilterOperators(showTime = false) {
    return [
      {
        value: 'is',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(
            filterItem,
            (value1, value2) => value1 === value2,
            showTime,
          );
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'not',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(
            filterItem,
            (value1, value2) => value1 !== value2,
            showTime,
          );
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'after',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(filterItem, (value1, value2) => value1 > value2, showTime);
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'onOrAfter',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(filterItem, (value1, value2) => value1 >= value2, showTime);
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'before',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(filterItem, (value1, value2) => value1 < value2, showTime);
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'onOrBefore',
        getApplyFilterFn: (filterItem) => {
          return buildApplyDateFilterFn(filterItem, (value1, value2) => value1 <= value2, showTime);
        },
        InputComponent: GridFilterDateInput,
        InputComponentProps: { showTime },
      },
      {
        value: 'isEmpty',
        getApplyFilterFn: () => {
          return ({ value }) => {
            return value == null;
          };
        },
        requiresFilterValue: false,
      },
      {
        value: 'isNotEmpty',
        getApplyFilterFn: () => {
          return ({ value }) => {
            return value != null;
          };
        },
        requiresFilterValue: false,
      },
    ];
  }


 function buildApplyDateFilterFn(filterItem, compareFn, showTime = false) {
    if (!filterItem.value) {
      return null;
    }

    // Make a copy of the date to not reset the hours in the original object
    const filterValueCopy = new Date(filterItem.value);
    filterValueCopy.setHours(0, 0, 0, 0);

    const filterValueMs = filterValueCopy.getTime();

    return ({ value }) => {
      if (!value) {
        return false;
      }

      // Make a copy of the date to not reset the hours in the original object
      const dateCopy = new Date(value);
      dateCopy.setHours(showTime ? value.getHours() : 0, showTime ? value.getMinutes() : 0, 0, 0);
      const cellValueMs = dateCopy.getTime();

      return compareFn(cellValueMs, filterValueMs);
    };
  }


   function GridFilterDateInput(props) {
        const { item, showTime, applyValue, apiRef } = props;
    
        const Component = showTime ? DateTimePicker : DatePicker;
    
        const handleFilterChange = (newValue) => {
          applyValue({ ...item, value: newValue });
        };
    
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Component
              value={item.value || null}
              label={apiRef.current.getLocaleText('filterPanelInputLabel')}
              slotProps={{
                textField: {
                  variant: 'standard',
                },
                inputAdornment: {
                  sx: {
                    '& .MuiButtonBase-root': {
                      marginRight: -1,
                    },
                  },
                },
              }}
              onChange={handleFilterChange}
            />
          </LocalizationProvider>
        );
      }


